<template>
  <div class="authentication-area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="authentication-form">
            <h2>Login</h2>

            <div v-if="error" class="alert alert-danger py-2 mb-3">{{ error }}</div>

            <form @submit.prevent="handleLogin">
              <div class="form-floating mb-4">
                <input
                  v-model="email"
                  type="email"
                  class="form-control"
                  id="floatingInput2"
                  placeholder="Email"
                  required
                />
                <label for="floatingInput2" class="floating">Email</label>
              </div>
              <div class="form-floating mb-4">
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  id="floatingInput1"
                  placeholder="Password"
                  required
                />
                <label for="floatingInput1" class="floating">Password</label>
              </div>
              <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                <div class="form-check mb-0"></div>
                <RouterLink to="/forgot-password" class="forgot mt-2 mt-sm-0">
                  FORGOT PASSWORD?
                </RouterLink>
              </div>
              <div class="text-center">
                <button type="submit" class="btn px-275" :disabled="loading">
                  <span class="border-style">
                    {{ loading ? "Logging in..." : "Login Now" }}
                  </span>
                </button>
              </div>
              <div class="py-4 text-center">
                Don't have an account?
                <RouterLink to="/register" class="text-white fw-bold">Register</RouterLink>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { useRecaptcha } from "@/composables/useRecaptcha";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  setup() {
    const email = ref("");
    const password = ref("");
    const error = ref("");
    const loading = ref(false);
    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();
    const { getToken } = useRecaptcha();

    async function handleLogin() {
      error.value = "";
      loading.value = true;
      try {
        const recaptchaToken = await getToken("login");
        await authStore.login(email.value, password.value, recaptchaToken);
        const redirect = (route.query.redirect as string)
          || (authStore.isAdmin ? "/admin" : "/dashboard");
        router.push(redirect);
      } catch (e: any) {
        error.value = e?.response?.data?.message || "Login failed. Please try again.";
      } finally {
        loading.value = false;
      }
    }

    return { email, password, error, loading, handleLogin };
  },
});
</script>
